module.exports = __webpack_public_path__ + "static/world-logo-64f4168086a3622d673efa34acd1f94e.png";